export function getPercentage(value: number, maxValue: number): number {
  if (maxValue <= 0) return 0;
  return (value / maxValue) * 100;
}

export function formatExpertRating(value: number | string): string {
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (value == null || value === "" || isNaN(num)) return "";
  return num.toFixed(1);
}
